import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
// import "./assets/css/default/bootstrap.min.css";
// import './assets/css/default/app.css'
// import './assets/css/icons.min.css'
import App from './App';

import './assets/css/bootstrap.min.css';
import './assets/css/icons.min.css';
import './assets/css/app.css';
import 'boxicons/css/boxicons.min.css';

// const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

